<template>
  <div class="cover-content table-wrapper">
    <!-- <high-search> -->
    <Form
      ref="formInline"
      :model="formInline"
      inline
      class="form-list"
      :label-width="100"
      label-position="right"
    >
      <Row :gutter="16">
        <Col span="6">
          <FormItem label="预警消息:" prop="noticeSmsContent">
            <Input
              clearable
              v-model="formInline.noticeSmsContent"
              placeholder="请输入预警消息"
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="预警编号:" prop="warningNumber">
            <Input
              clearable
              v-model="formInline.warningNumber"
              placeholder="请输入预警编号"
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="处理状态:" prop="handlingStatus">
            <Select clearable v-model="formInline.handlingStatus">
              <Option
                v-for="item in handlingList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6" class="high-search">
          <FormItem :label-width="0">
            <Button type="primary" @click="handleQuery">搜索</Button>
            <Button style="margin-left: 20px" @click="handleReset">重置</Button>
            <span
              :class="open ? 'search-open' : 'search-close'"
              @click="open = !open"
              >{{ open ? "收起" : "展开" }}
              <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'"
            /></span>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16" v-show="open">
        <Col span="6">
          <FormItem label="预警类型:" prop="warningType">
            <Select clearable v-model="formInline.warningType">
              <Option
                v-for="item in warningList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="紧急程度:" prop="urgency">
            <Select clearable v-model="formInline.urgency">
              <Option
                v-for="item in urgencyList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="预警时间:" prop="dateValue">
            <DatePicker
              clearable
              type="daterange"
              :options="options1"
              placeholder="请选择时间范围"
              v-model="dateValue"
              @on-change="dateChange"
            ></DatePicker>
          </FormItem>
        </Col>
        <Col span="6" v-if="areaType=='PROVINCE'">
          <FormItem label="预警对象:" prop="areaCode">
            <!-- <place-select v-model="formInline.areaCode"></place-select> -->
            <Select v-model="formInline.areaCode">
              <Option
                v-for="(item, index) in citises"
                :value="item.value"
                :key="index"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16" v-show="open">
        <Col span="6">
          <FormItem label="预警项:" prop="warningItem">
            <Select clearable v-model="formInline.warningItem">
              <Option
                v-for="item in warningItemList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <!-- </high-search> -->
    <div class="cover-table">
      <Table
        border
        style="width: 100%"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <template slot-scope="{ row, index }" slot="action">
          <span class="pointer" @click="handleDeal('alertDetails', row)"
            >详情</span
          >
        </template>
      </Table>
      <div class="t-page">
        <Page
          :total="totalCount"
          :page-size="pageSize"
          :current="page"
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
          show-elevator
          show-sizer
          show-total
          transfer
        >
        </Page>
      </div>
    </div>
  </div>
</template>
<script>
import tableMixin from "@/components/tableMixin";
import { getCityCodeLists } from "@/api/general";
export default {
  mixins: [tableMixin],
  data() {
    return {
      citises: [],
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "预警编号",
          key: "warningNumber",
          minWidth: 150,
          tooltip: true,
          align: "left",
        },
        {
          title: "预警时间",
          key: "warningTime",
          minWidth: 100,
          tooltip: true,
          align: "left",
        },
        {
          title: "紧急程度",
          key: "urgencyString",
          minWidth: 100,
          tooltip: true,
          align: "left",
        },
        {
          title: "预警消息",
          key: "noticeSmsContent",
          minWidth: 100,
          tooltip: true,
          align: "left",
        },
        {
          title: "预警类型",
          key: "warningTypeString",
          minWidth: 100,
          tooltip: true,
          align: "left",
        },
        {
          title: "预警项",
          key: "warningItemString",
          minWidth: 150,
          tooltip: true,
          align: "left",
        },
        {
          title: "已解除预警项",
          key: "warningHandledString",
          minWidth: 100,
          tooltip: true,
          align: "left",
        },
        {
          title: "待解除预警项",
          key: "warningRemainedString",
          minWidth: 100,
          tooltip: true,
          align: "left",
        },
        {
          title: "预警对象",
          key: "cityName",
          minWidth: 100,
          tooltip: true,
          align: "left",
        },
        {
          title: "处理状态",
          key: "handlingStatus",
          minWidth: 150,
          align: "left",
          render: (h, params) => {
            return h(
              "span",
              params.row.handlingStatus == 1
                ? "处理中"
                : params.row.handlingStatus == 2
                ? "已完成"
                : "已归档"
            );
          },
        },
        {
          title: "操作",
          slot: "action",
          fixed: "right",
          align: "center",
          minWidth: 100,
        },
      ],
      formInline: {
        areaCode: localStorage.getItem("tenantAreaCode"), // 地区
        startDate: "",
        endDate: "",
        areaCode: "",
        noticeSmsContent: "",
        warningType: "",
        warningItem: "",
        warningNumber: "",
        urgency: "",
        handlingStatus: "",
      },
      handlingList: [
        {
          value: 1,
          label: "处理中",
        },
        {
          value: 2,
          label: "已完成",
        },
        {
          value: 3,
          label: "已归档",
        },
      ],
      warningList: [
        {
          label: "更新率",
          value: 1,
        },
        {
          label: "管理人员到岗率",
          value: 2,
        },
        {
          label: "关键岗位预警",
          value: 3,
        },
        // {
        //   label: "一地接入、全省通用",
        //   value: 4,
        // },
      ],
      urgencyList: [
        {
          label: "较低",
          value: 1,
        },
        {
          label: "一般",
          value: 2,
        },
        {
          label: "重要",
          value: 3,
        },
        {
          label: "紧急",
          value: 4,
        },
      ],
      warningItemList: [
        {
          label: "项目更新率",
          value: 1,
        },
        {
          label: "有考勤的项目平均上班工人数",
          value: 2,
        },
        {
          label: "项目经理到岗率",
          value: 3,
        },
        {
          label: "总监理工程师到岗率",
          value: 4,
        },
        {
          label: "项目经理和总监理工程师平均到岗率",
          value: 5,
        },
        {
          label: "项目停工率",
          value: 6,
        },
        {
          label: "未设置项目经理的项目数",
          value: 7,
        },
        {
          label: "未设置总监理工程师的项目数",
          value: 8,
        },
        {
          label: "无效项目经理的项目数",
          value: 9,
        },
        {
          label: "无效总监理工程师的项目数",
          value: 10,
        },
        // {
        //   label: "项目超期未审核预警",
        //   value: 11,
        // },
        // {
        //   label: "供应商超期未联调预警",
        //   value: 12,
        // },
        // {
        //   label: "供应商超期未审核预警",
        //   value: 13,
        // },
      ],
      open: false,
      tableData: [],
      dateValue: [],
      options1: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
      areaType: ''
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.init();
  },
  watch: {},
  methods: {
    init() {
      this.$nextTick(() => {
        this.areaType = localStorage.getItem("areaType"),
        this.formInline.areaCode = localStorage.getItem("tenantAreaCode");
        let dayTime = new Date();
        let lw = new Date(dayTime - 1000 * 60 * 60 * 24 * 30); //最后一个数字30可改，30天的意思
        this.formInline.endDate = this.common.timeConvert(dayTime, 0);
        this.formInline.startDate = this.common.timeConvert(lw, 0);
        this.dateValue = [this.formInline.startDate, this.formInline.endDate];
        this.getCityCodeLists();
        this.getTableData();
      });
    },
    /*获取各市数据*/
    getCityCodeLists() {
      const params = {
        areaCode: localStorage.getItem("tenantAreaCode"),
      };
      getCityCodeLists(params)
        .then((res) => {
          this.citises = res.data.data[0].children;
        })
        .catch(() => {});
    },
    dateChange(e) {
      this.formInline.startDate = e[0];
      this.formInline.endDate = e[1];
      this.dateValue = e;
    },
    /*获取表格数据*/
    getTableData() {
      const params = {
        startDate: "",
        endDate: "",
        areaCode: "",
        noticeSmsContent: "",
        warningType: "",
        warningItem: "",
        warningNumber: "",
        urgency: "",
        handlingStatus: "",
        size: this.pageSize,
        current: this.page,
      };
      Object.assign(params, this.formInline);
      this.loading = true;
      this.axios({
        method: "post",
        url: "/gd/warningManagement/warningInfo",
        data: params,
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.totalCount = response.data.data.total;
            this.tableData = response.data.data.list;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleReset() {
      this.page = 1;
      this.pageSize = 10;
      let dayTime = new Date();
      let lw = new Date(dayTime - 1000 * 60 * 60 * 24 * 30); //最后一个数字30可改，30天的意思
      this.formInline.endDate = this.common.timeConvert(dayTime, 0);
      this.formInline.startDate = this.common.timeConvert(lw, 0);
      this.dateValue = [this.formInline.startDate, this.formInline.endDate];
      this.formInline.areaCode = localStorage.getItem("tenantAreaCode");
      this.formInline.noticeSmsContent = "";
      this.formInline.warningType = "";
      this.formInline.warningItem = "";
      this.formInline.warningNumber = "";
      this.formInline.urgency = "";
      this.formInline.handlingStatus = "";
      this.getTableData();
    },
    /*处理操作*/
    handleDeal(name, row) {
      this.$router.push({
        name: name,
        params: {
          earlyData: row,
            cityCode: row.cityCode,
        },
      });
    },
  },
};
</script>
<style scoped>
.wage_a {
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
